<template>
	<div class="layer-project" data-project-name="ket">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">Korea Electric Terminal</h1>
					<a href="http://www.ket.com" class="link" target="_blank"
						>www.ket.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						자동차, 전자, 정보통신 부품을 생산하는 한국단자의 글로벌 종합 부품
						기업의 이미지 제고와 기술력을 알릴 수 있는 콘텐츠를 강화된 검색으로
						쉽게 찾을 수 있는 방향으로 제작했습니다.
					</p>
					<dl class="project-overview-list">
						<div>
							<dt>
								<span>Modern &amp;Simple<br />Professional</span>
							</dt>
							<dd>정보와 기능을 직관적으로 인지하기 위한 브랜드 이미지</dd>
						</div>
						<div>
							<dt>
								<span>Easy Practical<br />Intuitivel</span>
							</dt>
							<dd>효과적인 제품 검색을 위한 메뉴 구조 개발</dd>
						</div>
						<div>
							<dt>
								<span>Comprehensive<br />Energetic</span>
							</dt>
							<dd>
								제품의 홍보 및 호감도를 <br class="blank tb" />높일 수 있는
								콘텐츠 디자인
							</dd>
						</div>
					</dl>
				</div>
			</section>

			<!-- section01 : pc-web -->
			<section class="section section01 full">
				<div class="inner-section">
					<div class="section-tit-wrap max-limit">
						<h2 class="project-subtit">PC Web</h2>
						<p class="section-desc">
							상단 비주얼 영역에 한국단자의 제품 이미지와 분야별 배너를 아이콘과
							<br class="blank tb" />함께 제공함으로써 직관성을 강조했습니다.
							<br class="blank pc" />빠른 검색으로 원하는 정보를
							<br class="blank tb" />바로 찾을 수 있게 검색 기능을
							강화하였습니다.
						</p>
					</div>
					<div class="section-img-wrap">
						<p class="project-img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket/view-01-main@m.jpg"
							/>
						</p>
						<p class="project-img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket/view-02-sub@m.jpg"
							/>
						</p>
						<p class="bg-number">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket/bg-number-01@m.png"
							/>
						</p>
					</div>
				</div>
			</section>

			<!-- section02 : products search system -->
			<section class="section section02">
				<div class="inner-section">
					<div class="section-tit-wrap">
						<h2 class="project-subtit">
							Products <br class="blank tb" /><br class="blank pc" />Search
							System
						</h2>
						<p class="section-desc">
							많은 제품의 검색을 시스템화하여 <br class="blank tb" />제품 분류
							및 내용을 <br class="blank pc" />찾기 쉽게
							<br class="blank tb" />구성할 수 있도록 UI설계 및 디자인
							<br class="blank tb" />하였습니다.
						</p>
					</div>
					<div class="section-img-wrap">
						<p class="project-img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket/view-03-search@m.jpg"
							/>
						</p>
						<p class="bg-number">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ket/bg-number-02@m.png"
							/>
						</p>
					</div>
				</div>
			</section>

			<!-- section03 : project identity -->
			<section class="section section03">
				<div class="inner-section">
					<div class="identity-icon-wrap">
						<ul class="identity-icon">
							<li>
								<img
									src="/static/img/project-detail/ket/identity-icon-01@m.png"
									alt="identity-icon-01"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/ket/identity-icon-02@m.png"
									alt="identity-icon-02"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/ket/identity-icon-03@m.png"
									alt="identity-icon-03"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/ket/identity-icon-04@m.png"
									alt="identity-icon-04"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/ket/identity-icon-05@m.png"
									alt="identity-icon-05"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/ket/identity-icon-06@m.png"
									alt="identity-icon-06"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/ket/identity-icon-07@m.png"
									alt="identity-icon-07"
								/>
							</li>
						</ul>
					</div>
					<dl class="identity-color">
						<div class="blue">
							<dt>Blue</dt>
							<dd>#3c7dcf</dd>
						</div>
						<div class="dark-blue">
							<dt>Dark Blue</dt>
							<dd>#233b65</dd>
						</div>
					</dl>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">Korea Electric Terminal</strong>
			</section>
			<!-- Details [e] -->
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
div[class^="rwd"] {
	display: none;
}
/* .layer-project-detail > .pd-none.full{padding:0} */
.project-subtit {
	line-height: 1.2;
}
.section.full .con-tit-area {
	max-width: 1280px;
	margin: 0 auto;
}
.section .cont-tit-area {
	word-break: keep-all;
}
.section .detail-img {
	text-align: center;
}
.section p {
	word-break: keep-all;
}
.blank {
	display: none;
}
.section {
	position: relative;
	word-break: keep-all;
}
.section .project-subtit span {
	display: block;
}
.section .section-desc {
	letter-spacing: -0.25px;
}
.section .section-img-wrap {
	position: relative;
}
.section .bg-number {
	position: absolute;
}
.section .project-img {
	position: relative;
	z-index: 10;
}
@media screen and (max-width: 711px) {
	div[class="rwd-mb"] {
		display: inline-block;
	}
	.section.full .max-limit {
		padding-left: 15px;
		padding-right: 15px;
	}
	.section .section-img-wrap {
		margin-top: 12.2vw;
	}
	.section .bg-number {
		z-index: 10;
	}
	.section .project-subtit {
		margin-bottom: 15px;
	}
	.section.section01.full {
		padding-bottom: 0;
	}
	.section .project-subtit {
		line-height: 1.2;
		letter-spacing: -0.25px;
	}
	.section .section-desc {
		font-size: 16px;
	}
	.blank.mb {
		display: block;
	}
}
@media screen and (min-width: 712px) {
	div[class="rwd-tb"] {
		display: inline-block;
	}
	.section.full .max-limit {
		padding-left: 40px;
		padding-right: 40px;
	}
	.section .project-subtit {
		margin-bottom: 14px;
	}
	.section .bg-number img {
		height: 150px;
	}
	.blank.tb {
		display: block;
	}
}
@media screen and (min-width: 1280px) {
	div[class="rwd-tb"] {
		display: none;
	}
	div[class="rwd-pc"] {
		display: inline-block;
	}
	.section.full {
		max-width: 1920px;
	}
	.section.full .max-limit {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 20px;
		padding-right: 20px;
	}
	.layer-project-detail > section.full {
		max-width: 1920px;
	}
	.section .bg-number img {
		height: auto;
	}
	.blank.tb {
		display: none;
	}
	.blank.pc {
		display: block;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/ket/ci.png) 50% / auto 53px
		no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ket/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ket/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 79px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ket/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 149px;
	}
}

/* Overview */
.project-overview {
	background-color: #3c7dcf;
	color: #fff;
	word-break: keep-all;
}
.project-overview-list {
	display: flex;
	align-items: center;
	justify-content: center;
	word-break: keep-all;
}
.project-overview-list div {
	position: relative;
}
.project-overview-list dt {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	border: 1px solid #fff;
	border-radius: 50%;
	font-weight: 500;
	text-align: center;
}
.project-overview-list dd {
	display: block;
	text-align: center;
	line-height: 1.8;
}
@media screen and (max-width: 711px) {
	.blank.mb {
		display: block;
	}
	.project-overview-list {
		display: block;
		margin-top: 48px;
	}
	.project-overview-list div {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}
	.project-overview-list div:nth-child(2) {
		top: -10px;
	}
	.project-overview-list div:nth-child(3) {
		top: -20px;
	}
	.project-overview-list dt {
		width: 130px;
		height: 130px;
		margin-right: 15px;
		font-size: 1.3rem;
	}
	.project-overview-list dd {
		width: 50%;
		text-align: left;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-txt span {
		display: inline;
	}
	.project-overview-list {
		margin-top: 29px;
	}
	.project-overview-list div {
		width: 170px;
	}
	.project-overview-list div:nth-child(1) {
		right: -10px;
	}
	.project-overview-list div:nth-child(3) {
		left: -10px;
	}
	.project-overview-list dt {
		height: 170px;
		margin-right: 15px;
	}
	.project-overview-list dd {
		padding: 14px;
		font-size: 12px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-tit {
		font-weight: 400;
	}
	.project-overview-txt {
		font-weight: 300;
	}
	.project-overview-txt span {
		display: block;
	}
	.project-overview-list {
		margin-top: 66px;
	}
	.project-overview-list div {
		width: 293px;
	}
	.project-overview-list div:nth-child(1) {
		right: -20px;
	}
	.project-overview-list div:nth-child(3) {
		left: -20px;
	}
	.project-overview-list dt {
		height: 293px;
		font-size: 20px;
	}
	.project-overview-list dd {
		padding: 28px 45px;
		font-size: 16px;
		line-height: 1.8;
	}
}
/* section1 */
@media screen and (max-width: 711px) {
	.section01 .project-subtit-wrap {
		padding: 0 15px;
	}
	.section01 .bg-number {
		top: 0;
		right: 0;
		transform: translate(-55%, -83%);
	}
	.section01 .bg-number img {
		width: 17.03vw;
	}
	.section01 .project-img {
		padding: 13px 0;
	}
}
@media screen and (min-width: 712px) {
	.section01 .project-subtit-wrap {
		padding: 0 40px;
	}
	.section01 .bg-number {
		top: -75px;
		right: 75px;
	}
	.section01 .section-img-wrap {
		padding-top: 70px;
	}
	.section01 .project-img {
		padding: 0;
	}
	.section01 .project-img:nth-child(1) {
		margin-bottom: 63px;
		text-align: right;
	}
	.section01 .project-img:nth-child(1) img {
		width: 79.14vw;
	}
	.section01 .project-img:nth-child(2) img {
		width: 78.65vw;
	}
}
@media screen and (min-width: 1280px) {
	.section01 .inner-section {
		padding-top: 110px;
	}
	.section01 .sub-text span {
		display: block;
	}
	.section01 .project-subtit-wrap {
		padding: 90px 20px 0;
	}
	.section01 .bg-number {
		top: -170px;
		right: 187px;
		transform: none;
	}
	.section01 .section-img-wrap {
		padding-top: 140px;
	}
	.section01 .project-img {
		padding: 0;
	}
	.section01 .project-img:nth-child(1) {
		margin-bottom: 230px;
	}
	.section01 .project-img:nth-child(1) img {
		width: 1407px;
	}
	.section01 .project-img:nth-child(2) img {
		width: 1481px;
	}
}

/* section2 */
.section02 {
	padding-top: 0;
}
.section02 .project-img img {
	width: 100%;
}
@media screen and (max-width: 711px) {
	.section.section02 {
		padding-top: 0;
		position: relative;
		top: -30px;
		z-index: 10;
	}
	.section02 .bg-number {
		top: 0;
		right: 0;
		transform: translateY(-70%);
	}
	.section02 .bg-number img {
		height: 15.31vw;
	}
}
@media screen and (min-width: 712px) {
	.section02 {
		min-height: 64.25vw;
	}
	.section02 .project-subtit-wrap {
		float: left;
		max-width: 28.7vw;
	}
	.section02 .project-img img {
		width: 56.2vw;
	}
	.section02 .bg-number {
		top: 50%;
		left: 0;
		transform: translateY(-10%);
	}
	.section02 .section-img-wrap {
		position: static;
		float: right;
	}
	.section02 .project-img {
		position: absolute;
		top: 15px;
		left: calc(50% - 70px);
	}
}
@media screen and (min-width: 1280px) {
	.section.section02 {
		position: relative;
		min-height: 1400px;
		padding-top: 100px;
		padding-right: 80px;
		overflow: hidden;
	}
	.section02 .bg-number {
		top: 350px;
		left: 0px;
		transform: none;
	}
	.section02 .project-subtit-wrap {
		position: absolute;
		top: 80px;
		left: 340px;
	}
	.section02 .project-subtit {
		margin-bottom: 40px;
	}
	.section02 .section-desc {
		font-size: 16px;
		line-height: 1.8;
	}
	.section02 .section-img-wrap {
		position: static;
		float: right;
		width: 1049px;
	}
	.section02 .project-img {
		position: absolute;
		top: 120px;
		left: calc(50% - 200px);
	}
	.section02 .project-img img {
		width: auto;
	}
}

/* section3 */
.section03 {
	background-color: #222;
}
.section03 .identity-icon {
	display: flex;
	flex-wrap: wrap;
}
.section03 .identity-color {
	display: flex;
	justify-content: center;
}
.section03 .identity-color div {
	color: #fff;
}
.section03 .identity-color .blue {
	background-color: #3c7dcf;
}
.section03 .identity-color .blue dd {
	color: #6397d9;
}
.section03 .identity-color .dark-blue {
	background-color: #233b65;
}
.section03 .identity-color .dark-blue dd {
	color: #4f6284;
}
@media screen and (max-width: 711px) {
	.section03 .identity-icon {
		justify-content: flex-start;
	}
	.section03 .identity-icon li {
		padding: 6px 2px;
	}
	.section03 .identity-icon li img {
		width: 68px;
	}
	.section03 .identity-color {
		justify-content: space-between;
		padding-top: 20px;
	}
	.section03 .identity-color div {
		width: 133px;
		height: 71px;
		padding: 14px 15px;
	}
}
@media screen and (min-width: 712px) {
	.section03 .identity-icon {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.section03 .identity-icon li {
		width: 68px;
		margin: 10px;
	}
	.section03 .identity-color {
		padding-top: 33px;
	}
	.section03 .identity-color div {
		width: 133px;
		height: 71px;
		padding: 14px 15px;
	}
	.section03 .identity-color .blue {
		margin-right: 24px;
	}
}
@media screen and (min-width: 1280px) {
	.section.section03 {
		padding: 130px 40px;
	}
	.section03 .identity-icon {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.section03 .identity-icon li {
		width: 136px;
		margin: 10px;
	}
	.section03 .identity-color {
		padding-top: 70px;
	}
	.section03 .identity-color div {
		width: 206px;
		height: 122px;
		padding: 28px;
		font-weight: 600;
	}
	.section03 .identity-color dt {
		font-size: 20px;
	}
	.section03 .identity-color dd {
		font-size: 16px;
	}
	.section03 .identity-color .blue {
		margin-right: 36px;
	}
}

@media screen and (min-width: 1280px) and (max-width: 1870px) {
	.section .project-subtit {
		font-size: 4.6rem;
	}
	.section02 .project-subtit-wrap {
		left: 12.85vw;
		max-width: 19.06vw;
	}
	.section02 .project-img img {
		width: 54.63vw;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/ket.vue